import ProcessNavigation from '@/components/process-navigation/index.vue';
import accountInfoService from '../../account-info.service.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    ProcessNavigation
  },
  computed: {
    ...mapGetters(['isHeilongjiang', 'userInfo'])
  },
  data() {
    return {
      processList: ['变更后法人信息', '业务审批员审批', '变更后法人验证'],
      status: 0,
      remark: ''
    };
  },
  created() {
    this.processList =  ['变更后法人信息', '业务审批员审批'];
    this.getCurrentUserStatus();
  },
  methods: {
    // 获取当前申请状态
    getCurrentUserStatus () {
      accountInfoService.getCurrentUserStatus().then(({ code, data }) => {
        if (code === '0') {
          this.status = data.status;
          this.remark = data.remark;
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 重新申请
    againApply() {
      this.$router.push('/person-center/account-info/modify-legal-first');
    },
    // 立即验证
    toVerification() {
      this.$router.push('/person-center/account-info/modify-legal-third');
    }
  }
};
